import React from 'react';
import { ArrowRight, MapPin, Sparkles, Clock, Navigation, AlertTriangle } from 'lucide-react';
interface DashboardOpportunitiesMapProps {
  onNavigateToOpportunities: () => void;
}
// Mock data matching Planner's OpportunityItem model
const opportunityPreviews = [{
  id: 801,
  address: 'Via Terenzio 3',
  timeWindow: '14:00 - 14:30',
  sqm: 55,
  urgency: 'Bassa',
  serviceType: 'Controllo Caldaia'
}, {
  id: 803,
  address: 'Via Germanico 20',
  timeWindow: '11:30 - 13:30',
  sqm: 80,
  urgency: 'Alta',
  serviceType: 'Tinteggiatura Parete'
}];
export function DashboardOpportunitiesMap({
  onNavigateToOpportunities
}: DashboardOpportunitiesMapProps) {
  const totalOpportunities = 12; // Mock total count
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden mb-8" data-id="element-113">
      {/* Header */}
      <div className="px-5 py-4 flex justify-between items-center border-b border-gray-100" data-id="element-114">
        <div className="flex items-center gap-2.5" data-id="element-115">
          <div className="w-8 h-8 rounded-lg bg-teal-deep/10 flex items-center justify-center" data-id="element-116">
            <Sparkles size={16} className="text-teal-deep" data-id="element-117" />
          </div>
          <div data-id="element-118">
            <h3 className="text-navy font-semibold text-sm" data-id="element-119">
              Prossime Opportunità
            </h3>
            <p className="text-[11px] text-gray-400" data-id="element-120">
              {totalOpportunities} interventi disponibili compatibili con i tuoi
              orari
            </p>
          </div>
        </div>
        <button onClick={onNavigateToOpportunities} className="flex items-center gap-1.5 text-xs font-medium text-teal-deep hover:text-teal-deep/80 transition-colors" data-id="element-121">
          Vedi tutte
          <ArrowRight size={14} data-id="element-122" />
        </button>
      </div>

      {/* Content Grid */}
      <div className="p-4" data-id="element-123">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4" data-id="element-124">
          {opportunityPreviews.map(item => <div key={item.id} className="flex items-center gap-3 p-3 bg-white border border-gray-200 rounded-xl hover:border-teal-deep/40 hover:shadow-sm transition-all group cursor-pointer" onClick={onNavigateToOpportunities} data-id="element-125">
              <div className="w-10 h-10 rounded-full bg-teal-deep/5 flex items-center justify-center flex-shrink-0 border border-teal-deep/10" data-id="element-126">
                <MapPin size={16} className="text-teal-deep" data-id="element-127" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-128">
                <div className="flex justify-between items-start mb-0.5" data-id="element-129">
                  <p className="text-xs font-bold text-navy truncate pr-2" data-id="element-130">
                    {item.serviceType}
                  </p>
                  {item.urgency === 'Alta' && <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[9px] font-medium bg-red-50 text-red-700 border border-red-100" data-id="element-131">
                      <AlertTriangle size={8} data-id="element-132" />
                      Urgente
                    </span>}
                </div>
                <div className="flex items-center gap-1.5 text-[10px] text-gray-500 mb-0.5" data-id="element-133">
                  <Clock size={10} className="text-teal-deep" data-id="element-134" />
                  <span className="font-medium" data-id="element-135">{item.timeWindow}</span>
                  <span className="text-gray-300" data-id="element-136">•</span>
                  <span data-id="element-137">{item.sqm} mq</span>
                </div>
                <p className="text-[10px] text-gray-400 truncate" data-id="element-138">
                  {item.address}
                </p>
              </div>
              <div className="w-6 h-6 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-teal-deep group-hover:text-white transition-colors" data-id="element-139">
                <ArrowRight size={12} data-id="element-140" />
              </div>
            </div>)}
        </div>

        {/* CTA */}
        <div className="flex justify-end" data-id="element-141">
          <button onClick={onNavigateToOpportunities} className="flex items-center justify-center gap-2 px-4 py-2.5 bg-teal-deep text-white rounded-lg text-sm font-medium hover:bg-teal-deep/90 shadow-sm transition-all" data-id="element-142">
            <Navigation size={16} data-id="element-143" />
            Esplora nel Pianificatore
          </button>
        </div>
      </div>
    </div>;
}